module.exports = __webpack_public_path__ + "img/bg.86f64da6.svg";